export const environment = {
  production: false,
  apiBaseUrl: 'https://api.test.firestore.livraison-express.net/api/v1.1',
  debugMode: true
}
